import type { NavigationGuard } from 'vue-router'
import { isValidMessageCategory, MessageCategories } from '@/enums/messageCategories.ts'
import { routeNames } from '@/router/names.ts'

export const messageCategoryGuard: NavigationGuard = (to, from, next) => {
    if (
        to.params.messageCategory &&
        typeof to.params.messageCategory === 'string' &&
        isValidMessageCategory(to.params.messageCategory)
    ) {
        return next()
    }

    next({
        name: routeNames.MESSAGES_LIST_VIEW_NAME,
        params: {
            messageCategory: MessageCategories.INBOX,
            subAccountId: to.params.subAccountId,
        },
    })
}
